import React from 'react'
import arrow from '/assets/Icon/Arrow_Down.svg'

const BackToTop = () => {
  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const [scrollDistance, setScrollDistance] = React.useState(false)

  React.useMemo(() => {
    const viewScrollToTop = () => {
      if (window.scrollY > 900) {
        setScrollDistance(true)
      } else {
        setScrollDistance(false)
      }
    }
    window.addEventListener('scroll', viewScrollToTop)
    return () => {
      window.removeEventListener('scroll', viewScrollToTop)
    }
  }, [])

  if (!scrollDistance) return null
  return (
    <div className="fixed bottom-0 right-0 z-[10000] flex items-center justify-center px-4 py-6">
      <button
        className="rounded-[50%] bg-white p-2"
        onClick={() => backToTop()}
      >
        <img src={arrow} alt="" className="inline size-6 rotate-180 pt-[2px]" />
      </button>
    </div>
  )
}

export default BackToTop
